import type { FaireProductEntity } from "../../entity_types/product";

export const p_jj7jvzw2hb: FaireProductEntity = {
  token: "p_jj7jvzw2hb",
  type: "product",
  name: "Mixed Floral Babydoll Dress",
  brandToken: "b_9e6f6x9c2j",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/75d7de039b2c0ae4cf6fe2843baba18e907dec876f901abaef0cab560ea18f0b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc63319629a2d8aa2efebfa1be75ea95ca76dd366a99dae78fa82c62d7ecc2f3.jpeg",
    "https://cdn.faire.com/fastly/8bd4a0920cd1efc80d4961abe6c673f30b913494ce7c13c7174e573d506346fa.jpeg",
    "https://cdn.faire.com/fastly/97fff738503272305223f8e58caa3fbed4f8e6cad2048f5df345e831eb53cff2.jpeg",
    "https://cdn.faire.com/fastly/de46cbbf9cbab4310b3d83edd220e693e65396e2900da2d40e360a87140af165.jpeg",
    "https://cdn.faire.com/fastly/f8ae3e7e71545d2e9c52fb430ca9c7ba12599dc51dd791185edfad18806852da.jpeg",
  ],
  priceDollars: 22.85,
  description:
    "Your girly girl will love this mixed floral babydoll dress. With two different floral patterns and a ruffle hem, this dress is sure to make her feel stylish.\n\n\n * Mixed floral print \n * Spaghetti straps, Elasticized waist with crochet trim detail \n * Ruffle hem with crochet trim detail, Lined bodice \n * Diaper cover for size 2T - 3T, Pull over styling \n * Machine Wash \n * Imported ",
  tags: [],
  msrpDollars: 45.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:54.527Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
